export default "__VITE_ASSET__BwgBRMMH__"